import { useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import Logo from "@/components/Logo";
import { Loader2, Mail, ArrowLeft } from "lucide-react";
import { toast } from "sonner";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/forgot-password", { email: email.trim() });
      setSent(true);
      toast.success(data?.message || "Eğer hesap varsa, bağlantı gönderildi.");
    } catch (err) {
      const detail = err?.response?.data?.detail;
      if (!err?.response) {
        toast.error("Sunucuya bağlanılamadı. Lütfen birkaç saniye sonra tekrar deneyin.");
      } else {
        toast.error(detail || "İstek gönderilemedi.");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-6 relative">
      <div className="absolute inset-0 bg-grid opacity-20" />
      <div className="absolute top-6 left-6"><Link to="/"><Logo /></Link></div>
      <div className="w-full max-w-md relative z-10">
        <div className="glass-strong rounded-3xl p-8" data-testid="forgot-password-page">
          <div className="w-12 h-12 rounded-xl bg-cyan-500/10 border border-cyan-500/30 flex items-center justify-center mb-4">
            <Mail size={20} className="text-cyan-300" strokeWidth={1.6} />
          </div>
          <h1 className="font-display text-3xl font-bold text-white mb-2">Şifremi unuttum</h1>
          <p className="text-slate-400 text-sm mb-7 leading-relaxed">
            Hesabınızın e-posta adresini girin, size sıfırlama bağlantısı göndereceğiz.
            Bağlantı 60 dakika boyunca geçerlidir.
          </p>

          {sent ? (
            <div className="rounded-xl bg-cyan-500/5 border border-cyan-500/20 p-5 text-sm text-slate-200 leading-relaxed" data-testid="forgot-password-sent">
              Eğer <strong className="text-white">{email}</strong> ile kayıtlı bir hesap varsa,
              şifre sıfırlama bağlantısı az önce gönderildi. Lütfen e-postanızı (spam klasörünü de) kontrol edin.
              <div className="mt-4">
                <Link to="/giris" className="text-cyan-400 hover:text-cyan-300 inline-flex items-center gap-1">
                  <ArrowLeft size={13} /> Giriş ekranına dön
                </Link>
              </div>
            </div>
          ) : (
            <form onSubmit={onSubmit} className="space-y-4">
              <div>
                <label className="text-xs text-slate-400 uppercase tracking-wider">E-posta</label>
                <input
                  type="email"
                  required
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="mt-2 w-full bg-black/40 border border-white/10 rounded-lg px-4 py-3 text-white focus:border-blue-500 focus:outline-none focus:ring-1 focus:ring-blue-500"
                  placeholder="ornek@isletmem.com"
                  data-testid="forgot-email"
                />
              </div>
              <button
                type="submit"
                disabled={loading}
                className="neon-btn w-full text-white font-semibold rounded-xl py-3.5 flex items-center justify-center gap-2 disabled:opacity-60"
                data-testid="forgot-submit"
              >
                {loading && <Loader2 size={16} className="animate-spin" />}
                Şifre sıfırlama bağlantısı gönder
              </button>
            </form>
          )}

          {!sent && (
            <div className="mt-6 text-center text-sm">
              <Link to="/giris" className="text-slate-400 hover:text-cyan-300 inline-flex items-center gap-1">
                <ArrowLeft size={13} /> Giriş ekranına dön
              </Link>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
